import React from 'react';
import { Link } from 'react-router-dom';
import Section from './shared/Section';
import Card from './shared/Card';
import Grid from './shared/Grid';
import Button from './shared/Button';
import { projectsData } from '../data/projects';
import * as FiIcons from 'react-icons/fi';

const { FiArrowRight } = FiIcons;

const Work = () => {
  // Show first 3 projects on homepage
  const featuredProjects = projectsData.slice(0, 3);

  return (
    <Section
      id="work"
      title="Our work"
      subtitle="Take a look at some of our recent projects and see how we've helped businesses achieve their digital goals."
      background="slate"
    >
      <Grid cols={{ default: 1, md: 2, lg: 3 }} className="mb-12">
        {featuredProjects.map((project, index) => (
          <Card
            key={project.id}
            title={project.title}
            description={project.shortDescription}
            image={project.image}
            badge={project.category}
            tags={project.tags.slice(0, 3)}
            result={project.results[0]}
            link={{
              to: `/projects/${project.slug}`,
              text: "View Details"
            }}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
            viewport={{ once: true }}
          />
        ))}
      </Grid>

      {/* CTA */}
      <div className="text-center">
        <Button
          variant="primary"
          size="lg"
          to="/projects"
          icon={FiArrowRight}
        >
          View All Projects
        </Button>
      </div>
    </Section>
  );
};

export default Work;